import React, { type ReactNode } from 'react';

import { useMediaQuery } from '@pkg/providers';

import { Typography } from '../../../../../../../../DesignSystem';

import { TypographyWrapper } from './styles';

export interface TextContainerProps {
    title: ReactNode;
    subtitle?: ReactNode;
}

export function TextContainer({ title, subtitle }: TextContainerProps) {
    const { desktop } = useMediaQuery();

    // TODO: `color` should be a token.
    const subtitleMarkup = subtitle ? (
        <TypographyWrapper>
            <Typography size={desktop ? 30 : 16} type="paragraph" variant="span" weight="600" color="#c4c4c4">
                {subtitle}
            </Typography>
        </TypographyWrapper>
    ) : null;

    // TODO: `title` should specify a `heading` level.
    return (
        <>
            <TypographyWrapper>
                <Typography size={desktop ? 50 : 30} type="headline" variant="span" weight="700">
                    {title}
                </Typography>
            </TypographyWrapper>

            {subtitleMarkup}
        </>
    );
}
